import {
  ModuleErrorButtonText,
  ModuleErrorMessage,
  ModuleErrorTitle,
} from './HomeModuleDef'
import './styles/homemodule.css'
import './styles/home-module-error.css'
import { ReactNode } from 'react'

export interface HomeModuleErrorProps {
  title?: string
  message?: string | ReactNode
  detail?: string | ReactNode
  buttonText?: string
  handleBack: () => void

}

const HomeModuleError = (props: HomeModuleErrorProps) => {
  return (
    <div className="homeModuleError">
      <img className="errorIcon" src="/icon/error.svg" alt="Error icon" />
      <div className="content">
        <div className="title">{props.title ?? ModuleErrorTitle.Default}</div>
        {props.detail && <div className="message">{props.detail}</div>}
        <div className="message">
          {props.message ?? ModuleErrorMessage.Default}
        </div>
      </div>
      <button
        className="errorButton"
        type="button"
        onClick={props.handleBack}
      >
        <div className="errorButtonText">
          {props.buttonText ?? ModuleErrorButtonText.Default}
        </div>
      </button>
    </div>
  )
}

export default HomeModuleError
